module.exports = __webpack_public_path__ + "img/logo.f2f78d49.png";